var path = '/opt/atlassian/pipelines/agent/build/src/app/root.html';
var html = "<div class=root> <div ui-view></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/root.html
// module id = 991
// module chunks = 0